/* [PATCH dc-zaklep-okno v1] Potrditveno okno za zaklep/odklep meseca (Pregled dela, Skupinski pregled dela).
   Nadomešča window.confirm (Janez 07.10.2026: »zakleni mesec mora biti lepša maska«). Esc ali klik ob oknu = prekliči. */
import React, { useEffect } from 'react';
import { Lock, LockOpen, Loader, AlertTriangle } from 'lucide-react';

type Baza = { ime: string; zaposlenih?: number };

export function ZaklepOkno({ odprto, zakleni, mesec, baze, zaposlenih, nepotrjenih = 0, dela = false, onPotrdi, onPreklici }: {
  odprto: boolean; zakleni: boolean; mesec: string; baze?: Baza[]; zaposlenih?: number; nepotrjenih?: number; dela?: boolean;
  onPotrdi: () => void; onPreklici: () => void;
}) {
  useEffect(() => {
    if (!odprto) return;
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape' && !dela) onPreklici(); };
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [odprto, dela, onPreklici]);
  if (!odprto) return null;
  const Ikona = zakleni ? Lock : LockOpen;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40" onClick={() => { if (!dela) onPreklici(); }}>
      <div className="w-full max-w-lg rounded-2xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow-xl p-6 space-y-4"
        onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="flex items-start gap-3">
          <div className={'w-10 h-10 rounded-full flex items-center justify-center shrink-0 ' + (zakleni ? 'bg-amber-100 text-amber-700' : 'bg-blue-100 text-blue-700')}>
            <Ikona className="w-5 h-5" /></div>
          <div>
            <div className="text-base font-semibold text-gray-900 dark:text-white">{zakleni ? 'Zaklenem' : 'Odklenem'} {mesec.toLowerCase()}?</div>
            <div className="text-sm text-gray-500 mt-0.5">
              {baze ? `${baze.length} ${baze.length === 1 ? 'baza' : baze.length === 2 ? 'bazi' : baze.length < 5 ? 'baze' : 'baz'} · ${baze.reduce((s, b) => s + (b.zaposlenih || 0), 0)} zaposlenih`
                : `${zaposlenih ?? 0} zaposlenih`}</div>
          </div>
        </div>
        {baze && baze.length > 0 && (
          <div className="rounded-xl border border-gray-200 dark:border-gray-700 divide-y divide-gray-100 dark:divide-gray-800 max-h-56 overflow-y-auto">
            {baze.map((b, i) => (
              <div key={i} className="flex items-center justify-between gap-3 px-3 py-2 text-sm">
                <span className="truncate" title={b.ime}>{b.ime}</span>
                {b.zaposlenih != null && <span className="text-xs text-gray-500 shrink-0">{b.zaposlenih} zap.</span>}
              </div>))}
          </div>)}
        {zakleni ? (
          <div className="flex items-start gap-2 text-xs px-3 py-2.5 rounded-lg bg-amber-50 text-amber-800 border border-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:border-amber-500/30">
            <AlertTriangle className="w-4 h-4 shrink-0 mt-px" />
            <span>{nepotrjenih > 0 && <><b>{nepotrjenih} nepotrjenih</b> mesecev se ob zaklepu potrdi. </>}
              Delovnega časa in potnih nalogov tega meseca ne more urejati nihče, dokler administrator meseca ne odklene.</span>
          </div>
        ) : (
          <div className="text-xs px-3 py-2.5 rounded-lg bg-blue-50 text-blue-800 border border-blue-200 dark:bg-blue-500/10 dark:text-blue-300 dark:border-blue-500/30">
            Po odklepu se delovni čas in potni nalogi tega meseca spet urejajo. Potrditve mesecev ostanejo.</div>
        )}
        <div className="flex justify-end gap-2 pt-1">
          <button type="button" disabled={dela} onClick={onPreklici}
            className="px-4 py-2 rounded-lg text-sm font-medium border border-gray-200 dark:border-gray-700 hover:border-blue-400 bg-white dark:bg-gray-900 disabled:opacity-50">Prekliči</button>
          <button type="button" disabled={dela} onClick={onPotrdi}
            className={'px-4 py-2 rounded-lg text-sm font-medium text-white inline-flex items-center gap-2 disabled:opacity-50 ' + (zakleni ? 'bg-amber-600 hover:bg-amber-700' : 'bg-blue-600 hover:bg-blue-700')}>
            {dela ? <Loader className="w-4 h-4 animate-spin" /> : <Ikona className="w-4 h-4" />}{zakleni ? 'Zakleni' : 'Odkleni'}</button>
        </div>
      </div>
    </div>
  );
}

export default ZaklepOkno;
